import React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import { cancelButtonSx } from '../hpcAdminStatusStyles';
import { HPC_COLORS } from '../hpcTheme';

const deleteButtonSx = {
  backgroundColor: '#c62828',
  color: '#ffffff',
  fontWeight: 700,
  textTransform: 'none',
  border: '2px solid #ef5350',
  '&:hover': {
    backgroundColor: '#d32f2f',
    border: '2px solid #ff7961',
  },
  '&.Mui-disabled': {
    color: 'rgba(255,255,255,0.5)',
    backgroundColor: 'rgba(198, 40, 40, 0.4)',
    border: '2px solid rgba(239, 83, 80, 0.4)',
  },
};

const DeleteAssessmentDialog = ({
  open,
  target,
  deleting,
  onCancel,
  onConfirm,
}) => (
  <Dialog open={open} onClose={deleting ? undefined : onCancel} maxWidth="xs" fullWidth>
    <DialogTitle sx={{ fontWeight: 700 }}>Delete assessment?</DialogTitle>
    <DialogContent>
      <DialogContentText sx={{ color: HPC_COLORS.silver }}>
        {target ? (
          <>
            This will permanently delete the assessment for{' '}
            <strong style={{ color: HPC_COLORS.white }}>{target.member_name || target.membership_id}</strong>
            {' '}on <strong style={{ color: HPC_COLORS.white }}>{target.assessment_date}</strong>
            {' '}(status: {target.status}). This action cannot be undone.
          </>
        ) : (
          'This action cannot be undone.'
        )}
      </DialogContentText>
    </DialogContent>
    <DialogActions sx={{ px: 3, pb: 2 }}>
      <Button onClick={onCancel} disabled={deleting} sx={cancelButtonSx}>
        Cancel
      </Button>
      <Button onClick={onConfirm} disabled={deleting} variant="contained" sx={deleteButtonSx}>
        {deleting ? 'Deleting…' : 'Delete'}
      </Button>
    </DialogActions>
  </Dialog>
);

export { deleteButtonSx };
export default DeleteAssessmentDialog;
